<template>
  <path
    d="M5.71001 9.70021C6.10001 10.0902 6.73001 10.0902 7.12001 9.70021L11 5.83021V21.0002C11 21.5502 11.45 22.0002 12 22.0002C12.55 22.0002 13 21.5502 13 21.0002V5.83021L16.88 9.71021C17.27 10.1002 17.9 10.1002 18.29 9.71021C18.68 9.32021 18.68 8.69021 18.29 8.30021L12.7 2.70021C12.31 2.31021 11.68 2.31021 11.29 2.70021L5.71001 8.29021C5.32001 8.68021 5.32001 9.32021 5.71001 9.70021Z"
  />
</template>
